import { getColor } from '@customer-portal/shared/helpers/theme-utils';

export const progressbarOverride = {
  root: {
    background: getColor('Sandstone90'),
  },
  value: {
    background: getColor('SkyBlue55'),
  },
};
